import { Module } from "wrapper6";

export default class ObjectFit extends Module {
  ready() {

    /**
     * Object-fit poly-fill for IE & Edge
     */

    if ('objectFit' in document.documentElement.style === false) {
      var container = document.getElementsByClassName('object-fit');

      for (var i = 0; i < container.length; i++) {
        var imageSource = container[i].querySelector('img').src;
        container[i].querySelector('img').style.display = 'none';
        container[i].style.backgroundSize = 'cover';
        container[i].style.backgroundImage = 'url(' + imageSource + ')';
        container[i].style.backgroundPosition = 'center center';
        container[i].style.backgroundRepeat = 'no-repeat';
      }
    }
  }
}